import { DashboardAnalyticsData } from '../types/analytics.types';

export const mockAnalyticsData: DashboardAnalyticsData = {
  periodo: 'Últimos 30 dias',

  visaoGeral: {
    taxaRespostaGeral: 42.5,
    taxaSucessoGeral: 28.4,
    totalAcordos: 1650,
    totalMensagensEnviadas: 15430,
    totalRespostasRecebidas: 6557,
    baseAtiva: 4210,
    baseTotal: 5800,
    percentualBaseAtiva: 72.5,
    tempoMedioResposta: '2h 15min',
    tempoMedianoResposta: '45min',
  },

  temporal: {
    taxaRespostaPorHora: [
      { hora: 8, taxaResposta: 15, totalEnviadas: 500, totalRespostas: 75 },
      { hora: 9, taxaResposta: 35, totalEnviadas: 1200, totalRespostas: 420 },
      { hora: 10, taxaResposta: 48, totalEnviadas: 1500, totalRespostas: 720 },
      { hora: 11, taxaResposta: 42, totalEnviadas: 1300, totalRespostas: 546 },
      { hora: 12, taxaResposta: 25, totalEnviadas: 800, totalRespostas: 200 },
      { hora: 13, taxaResposta: 30, totalEnviadas: 900, totalRespostas: 270 },
      { hora: 14, taxaResposta: 65, totalEnviadas: 1600, totalRespostas: 1040 },
      { hora: 15, taxaResposta: 68, totalEnviadas: 1800, totalRespostas: 1224 },
      { hora: 16, taxaResposta: 55, totalEnviadas: 1400, totalRespostas: 770 },
      { hora: 17, taxaResposta: 45, totalEnviadas: 1100, totalRespostas: 495 },
      { hora: 18, taxaResposta: 35, totalEnviadas: 800, totalRespostas: 280 },
      { hora: 19, taxaResposta: 20, totalEnviadas: 400, totalRespostas: 80 },
    ],
    taxaRespostaPorDia: [
      { diaSemana: 'Segunda', taxaResposta: 38, totalEnviadas: 3200, totalRespostas: 1216 },
      { diaSemana: 'Terça', taxaResposta: 52, totalEnviadas: 3500, totalRespostas: 1820 },
      { diaSemana: 'Quarta', taxaResposta: 48, totalEnviadas: 3400, totalRespostas: 1632 },
      { diaSemana: 'Quinta', taxaResposta: 55, totalEnviadas: 3600, totalRespostas: 1980 },
      { diaSemana: 'Sexta', taxaResposta: 35, totalEnviadas: 2800, totalRespostas: 980 },
      { diaSemana: 'Sábado', taxaResposta: 15, totalEnviadas: 500, totalRespostas: 75 },
      { diaSemana: 'Domingo', taxaResposta: 8, totalEnviadas: 200, totalRespostas: 16 },
    ],
    melhoresHorarios: [
      {
        periodo: '14h - 16h',
        taxaResposta: 66.5,
        recomendacao: 'Ideal para envio de propostas iniciais',
      },
      { periodo: '09h - 11h', taxaResposta: 45.0, recomendacao: 'Bom para lembretes e follow-ups' },
    ],
    melhoresDias: ['Terça', 'Quinta'],
  },

  valores: {
    faixasValor: [
      {
        faixaMinima: 0,
        faixaMaxima: 500,
        label: 'Até R$ 500',
        totalCasos: 1200,
        taxaResposta: 25,
        taxaSucesso: 15,
        valorMedioAcordo: 350,
        tempoMedioNegociacao: 5,
      },
      {
        faixaMinima: 501,
        faixaMaxima: 2000,
        label: 'R$ 501 - R$ 2k',
        totalCasos: 2500,
        taxaResposta: 65,
        taxaSucesso: 72,
        valorMedioAcordo: 1200,
        tempoMedioNegociacao: 3,
      },
      {
        faixaMinima: 2001,
        faixaMaxima: 5000,
        label: 'R$ 2k - R$ 5k',
        totalCasos: 1500,
        taxaResposta: 55,
        taxaSucesso: 48,
        valorMedioAcordo: 3500,
        tempoMedioNegociacao: 7,
      },
      {
        faixaMinima: 5001,
        faixaMaxima: 10000,
        label: 'R$ 5k - R$ 10k',
        totalCasos: 800,
        taxaResposta: 45,
        taxaSucesso: 32,
        valorMedioAcordo: 7500,
        tempoMedioNegociacao: 12,
      },
      {
        faixaMinima: 10001,
        faixaMaxima: 999999,
        label: 'Acima de R$ 10k',
        totalCasos: 300,
        taxaResposta: 35,
        taxaSucesso: 18,
        valorMedioAcordo: 15000,
        tempoMedioNegociacao: 20,
      },
    ],
    faixaMaisEfetiva: {
      faixa: 'R$ 501 - R$ 2.000',
      taxaSucesso: 72,
      motivoPrincipal: 'Valores percebidos como pagáveis em poucas parcelas',
    },
  },

  qualitativo: {
    duvidas: {
      topDuvidas: [
        {
          tema: 'Formas de Pagamento',
          perguntasExemplo: ['Aceita pix?', 'Pode parcelar no boleto?', 'Quantas vezes no cartão?'],
          frequencia: 450,
          percentual: 35,
          sentimentoMedio: 0.2,
          respostaPadrao: 'Sim, aceitamos Pix e parcelamento em até 12x no boleto.',
        },
        {
          tema: 'Prazos',
          perguntasExemplo: ['Até quando posso pagar?', 'Qual a data de vencimento?'],
          frequencia: 320,
          percentual: 25,
          sentimentoMedio: 0.1,
          respostaPadrao: 'O vencimento da primeira parcela é para 5 dias úteis.',
        },
        {
          tema: 'Descontos',
          perguntasExemplo: ['Tem desconto à vista?', 'Consegue tirar os juros?'],
          frequencia: 280,
          percentual: 22,
          sentimentoMedio: -0.1,
          respostaPadrao: 'Para pagamento à vista conseguimos isentar 100% dos juros.',
        },
        {
          tema: 'Segurança',
          perguntasExemplo: ['É golpe?', 'Como sei que é verdade?'],
          frequencia: 150,
          percentual: 12,
          sentimentoMedio: -0.5,
          respostaPadrao: 'Somos a empresa X, você pode confirmar nosso contato no site oficial.',
        },
      ],
      nuvemPalavras: [
        { text: 'pagamento', value: 100 },
        { text: 'boleto', value: 85 },
        { text: 'parcelar', value: 80 },
        { text: 'desconto', value: 70 },
        { text: 'pix', value: 65 },
        { text: 'juros', value: 60 },
        { text: 'vencimento', value: 55 },
        { text: 'prazo', value: 50 },
        { text: 'acordo', value: 45 },
        { text: 'valor', value: 40 },
        { text: 'divida', value: 35 },
        { text: 'cartão', value: 30 },
        { text: 'confiavel', value: 25 },
        { text: 'golpe', value: 20 },
        { text: 'nome limpo', value: 15 },
      ],
    },
    objecoes: {
      topObjecoes: [
        {
          objecao: 'Valor muito alto',
          exemplosMensagens: ['Não tenho esse dinheiro', 'Muito caro', 'Impossível pagar isso'],
          frequencia: 380,
          percentual: 42,
          statusAposObjecao: { continuouNegociacao: 50, desistiu: 40, fezAcordo: 10 },
          sugestaoIa: 'Oferecer parcelamento estendido ou desconto maior à vista',
        },
        {
          objecao: 'Desempregado',
          exemplosMensagens: ['Estou sem emprego', 'Perdi a renda', 'Sem condições agora'],
          frequencia: 250,
          percentual: 28,
          statusAposObjecao: { continuouNegociacao: 20, desistiu: 75, fezAcordo: 5 },
          sugestaoIa: 'Sugerir pausa na negociação ou valor simbólico de entrada',
        },
        {
          objecao: 'Não reconhece dívida',
          exemplosMensagens: ['Não devo nada', 'Já paguei', 'Erro de vocês'],
          frequencia: 120,
          percentual: 13,
          statusAposObjecao: { continuouNegociacao: 60, desistiu: 30, fezAcordo: 10 },
          sugestaoIa: 'Enviar comprovante/detalhamento da dívida imediatamente',
        },
      ],
      taxaConversaoAposObjecao: 25,
    },
    sentimento: {
      distribuicaoSentimento: {
        positivo: 35,
        neutro: 45,
        negativo: 20,
      },
      evolucaoSentimento: [
        { dataHora: '2023-10-01', sentimentoMedio: 0.1 },
        { dataHora: '2023-10-02', sentimentoMedio: 0.2 },
        { dataHora: '2023-10-03', sentimentoMedio: 0.15 },
        { dataHora: '2023-10-04', sentimentoMedio: 0.3 },
        { dataHora: '2023-10-05', sentimentoMedio: 0.25 },
      ],
      sentimentoPorStatus: [
        { status: 'Fechado', sentimentoMedio: 0.8 },
        { status: 'Em andamento', sentimentoMedio: 0.2 },
        { status: 'Cancelado', sentimentoMedio: -0.4 },
      ],
    },
  },

  qualidadeBase: {
    totalContatos: 5800,
    contatosAtivos: 4210,
    contatosInativos: 1590,
    segmentacao: [
      { segmento: 'Alto Engajamento', quantidade: 1200, criterio: 'Responde em < 1h' },
      { segmento: 'Médio Engajamento', quantidade: 2500, criterio: 'Responde em < 24h' },
      {
        segmento: 'Baixo Engajamento',
        quantidade: 2100,
        criterio: 'Responde em > 24h ou não responde',
      },
    ],
    mensagensEnviadas: 15430,
    mensagensEntregues: 14800,
    mensagensLidas: 12500,
    taxaEntrega: 96,
    taxaLeitura: 84.5,
    contatosPerdidos: 350,
  },

  recomendacoes: {
    melhorHorarioEnvio: {
      periodo: '14h - 16h',
      diaSemana: ['Terça', 'Quinta'],
      taxaRespostaEsperada: 68,
      fundamentacao: 'Baseado em 458 negociações recentes com perfil similar.',
    },
    faixaValorOtima: {
      min: 500,
      max: 2000,
      taxaSucessoEsperada: 72,
      fundamentacao: 'Faixa com maior conversão e menor tempo de negociação.',
    },
    estrategiasEfetivas: [
      { estrategia: 'Oferta de parcelamento imediato', resultadoMedio: 45, quantidadeTestes: 120 },
      { estrategia: 'Mensagem de urgência (prazo)', resultadoMedio: 38, quantidadeTestes: 95 },
    ],
    alertas: [
      {
        tipo: 'warning',
        titulo: 'Queda na taxa de leitura',
        mensagem:
          'A taxa de leitura caiu 5% nos últimos 3 dias. Verifique se o número foi reportado como spam.',
        acao: 'Verificar saúde do número',
      },
      {
        tipo: 'info',
        titulo: 'Novo padrão de objeção',
        mensagem:
          "Detectamos aumento de objeções sobre 'Juros Abusivos'. Considere ajustar o script inicial.",
        acao: 'Revisar script',
      },
    ],
  },
};
